import * as React from 'react';
import { Button, Dropdown } from 'semantic-ui-react';
import { Format } from '~/Api/Report';
export var ExportButton = function (_a) {
    var exportReport = _a.exportReport, disabled = _a.disabled;
    return (<Button.Group compact primary disabled={disabled} floated='right' size='tiny'>
		<Button data-testid={"export-".concat(Format.xls)} onClick={function () {
            exportReport(Format.xls);
        }}>
			Exportovat do XLS
		</Button>
		<Dropdown floating className='button icon' data-testid='export-dropdown' trigger={<></>}>
			<Dropdown.Menu>
				<Dropdown.Item data-testid={"export-".concat(Format.csv)} onClick={function () {
            exportReport(Format.csv);
        }}>
					Exportovat do CSV
				</Dropdown.Item>
				<Dropdown.Item data-testid={"export-".concat(Format.pdf)} onClick={function () {
            exportReport(Format.pdf);
        }}>
					Exportovat do PDF
				</Dropdown.Item>
			</Dropdown.Menu>
		</Dropdown>
	</Button.Group>);
};
